import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
export const CircleButton = styled.button `
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  /** colors */
  background-color: ${({ theme }) => theme.backToTop.background};
  color: ${({ theme }) => theme.backToTop.icon};
  box-shadow: 0 4px 8px 0 ${({ theme }) => theme.backToTop.shadow};
  :hover {
    background-color: ${({ theme }) => theme.backToTop.hover.background};
    color: ${({ theme }) => theme.backToTop.hover.icon};
  }
  :active {
    background-color: ${({ theme }) => theme.backToTop.active.background};
    color: ${({ theme }) => theme.backToTop.active.icon};
  }
`;
export const ArrowUpIcon = styled(FontAwesomeIcon) `
  font-size: 16px;
`;
